import { render, staticRenderFns } from "./SchedaMacchina.vue?vue&type=template&id=5b6d5028&scoped=true"
import script from "./SchedaMacchina.vue?vue&type=script&lang=js"
export * from "./SchedaMacchina.vue?vue&type=script&lang=js"
import style0 from "./SchedaMacchina.vue?vue&type=style&index=0&id=5b6d5028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d5028",
  null
  
)

export default component.exports